import {
  BASE_URL,
  MAP_LOADED,
  BASE_USER_INFO
} from './mutations-type.js'
import Bus from '@/assets/js/vueBus'
// import { loadSudoku, loadLanguageJs, loadHeaderJs } from '@/assets/js/loadSudoku.js';
import Outil from '@/assets/js/utils.js'

export default {
  baseUrl ({
    commit,
    state
  }) {
    const lastVersion = window.localStorage.getItem('lastChannelVersion')
    const currentVersion = window.localStorage.getItem('newChannelVersion')
    const newCCConfig = window.localStorage.channelInitConfig
    // const domainName = `${window.location.protocol}//${window.location.host}`
    const domainName = '/ccp'
    // 判断是否更新重新请求接口
    if ((lastVersion != currentVersion) || !newCCConfig) {
      $.ajax({
        url: '/tvu-playout/base/initConfig',
        type: 'get',
        async: false,
        // headers: { Authorization: Outil.getSession() },
        success (data) {
          if (data.errorCode == '0x0' && data.errorInfo == 'Success') {
            const result = data.result || {}
            const portForhttpOrHttps = result.portForhttpOrHttps ? result.portForhttpOrHttps : []
            // 设置url存储在store中
            if (document.location.protocol === 'https:') {
              Object.keys(result).forEach((key) => {
                portForhttpOrHttps.forEach((v) => {
                  if (v.key == key) {
                    if (typeof result[key] == 'string') {
                      result[key] = result[key].replace(v.http, v.https)
                    }
                  }
                })
              })
            }
            const val = { urlInfo: result } || {}
            // 设置url存储在store中
            commit(BASE_URL, val)
            // 设置url存储在localstroge
            window.localStorage.channelInitConfig = JSON.stringify(val)

            // 存储跳转地址
            const { newuserserviceLoginUrl } = result
            localStorage.setItem('newuserserviceLoginUrl', newuserserviceLoginUrl)

            // 设置上一次版本号
            localStorage.setItem('lastChannelVersion', currentVersion)

            // configT和dashboard地址
            localStorage.setItem('newCCUrl', data.result.mySourceUrl)
            localStorage.setItem('cloudDriveGateWayUrl', data.result.cloudDriveGateWayUrl)
            localStorage.setItem('cloudDriveUrl', data.result.cloudDriveUrl)
          }
        }
      })
    } else {
      const channelInitConfig = JSON.parse(window.localStorage.channelInitConfig)
      // 设置url存储在store中
      const result = channelInitConfig.urlInfo
      // 设置url存储在store中
      commit(BASE_URL, { urlInfo: result })
    }
  },
  baseUserInfo ({
    commit,
    state
  }) {
    const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
    const gatewayPlayoutUrl = `${window.location.protocol}//${urlInfo.gatewayPlayoutUrl}`
    $.ajax({
      url: `${gatewayPlayoutUrl}/tvu-playout/user/initLoginUser`,
      type: 'get',
      async: false,
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      success (res, status, xhr) {
        if (res.errorCode == '0x0') {
          const data = { userInfo: res.result } || {}
          localStorage.setItem('userId', res.result.id)
          localStorage.setItem('roleId', res.result.role)
          commit(BASE_USER_INFO, data)
        }
      },
      error (xhr) {
        if (xhr.status == 401 || xhr.status == 402) {
          console.log(`initLoginUser ...${xhr}`)
          Bus.$emit('jumpLoginPage')
        }
      }
    })
  },
  mapLoad ({
    commit,
    state,
    rootState
  }) {
    commit(MAP_LOADED, 'true')
  }
}
